'use strict';

const Verifier = require('../system/Verifier');

module.exports = function(props, propName, componentName) {
	if (!Verifier.isInstance(props[propName])) {
		return new Error(
			'Invalid prop `' +
				propName +
				'` supplied to' +
				' `' +
				componentName +
				'`. Not an instance of Verifier.'
		);
	}
};
